import { Component, Input } from '@angular/core';
import { Report } from '../../../../models/report.model';

@Component({
  selector: 'app-valeur-estimee-avec-plus-ou-moins-values',
  templateUrl: './valeur-estimee-avec-plus-ou-moins-values.component.html',
  styleUrls: ['./valeur-estimee-avec-plus-ou-moins-values.component.scss'],
})
export class ValeurEstimeeAvecPlusOuMoinsValuesComponent {
  @Input() appraisal!: Report.Appraisal;
}
